import SearchController from '../common/SearchController';

/**
 * Страна - дешевые туры: /india/tour-cost
 * Страна - месяц /india/july
 * Страна - сезон /india/summer
 * Страна - курорт /india/resorts/goa
 * Страна - курорт месяц /india/resorts/goa/july
 * Страна - курорт сезон /india/resorts/goa/summer
 */
$(() => {
    const searchController = new SearchController({
        el: 'body',
    });

    searchController.initSearchOnScroll();
});
